import React from 'react';
import { usePeopleMagicProfitEmailModalControl } from 'src/organisms/Standard/ProfitSales/2024_Q3_profit_sales_redesign/EmailModal/usePeopleMagicProfitEmailModalControl';
import { OptInGetFreeMasterclassContainer } from './OptInGetFreeMasterclass.styles';
import AnimatedMightyLogo from 'src/elements/AnimatedMightyLogo/AnimatedMightyLogo';
import ButtonPrimary from 'src/elements/buttons/2023_Q4/ButtonPrimary';

const OptInGetFreeMasterclass = (): JSX.Element => {
  const { open } = usePeopleMagicProfitEmailModalControl();

  return (
    <OptInGetFreeMasterclassContainer>
      <AnimatedMightyLogo isAnimated={false} />
      <ButtonPrimary
        text='Get the FREE Masterclass'
        customFontWeight={700}
        customBorderRadius={32}
        colorScheme='Sunshine'
        onClick={open}
      />
    </OptInGetFreeMasterclassContainer>
  );
};

export default OptInGetFreeMasterclass;
